// src/pages/Error.jsx
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Error() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-white p-8 rounded-lg shadow-xl text-center max-w-md w-full"
            >
                <div className="text-6xl mb-4">😕</div>
                <h1 className="text-3xl font-bold text-gray-800 mb-2">Página no encontrada</h1>
                <p className="text-gray-600 mb-6">
                    Lo sentimos, la página que buscas no existe o ha ocurrido un error.
                </p>
                <button
                    onClick={() => navigate('/')}
                    className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
                >
                    Volver al inicio
                </button>
            </motion.div>
        </div>
    );
}